import { Application } from "@hotwired/stimulus"
import { Tabs, Dropdown, Slideover, ColorPreview  } from 'tailwindcss-stimulus-components';
import AccordionController from '@kanety/stimulus-accordion';
import Notification from 'stimulus-notification';
import NestedForm from 'stimulus-rails-nested-form';
import Sortable from '@stimulus-components/sortable';
import PasswordVisibility from '@stimulus-components/password-visibility';
import Clipboard from '@stimulus-components/clipboard';

const application = Application.start();
application.debug = false;
window.Stimulus = application;

import controllers from "./*_controller.js";

controllers.forEach((controller) => {
    const controllerName = controller.name.replace(/_/g, '-');
    application.register(controllerName, controller.module.default)
});

Stimulus.register('notification', Notification);
Stimulus.register('dropdown', Dropdown);
Stimulus.register('tabs', Tabs);
Stimulus.register('slideover', Slideover);
Stimulus.register('accordion', AccordionController);
Stimulus.register('nested-form', NestedForm);
Stimulus.register('sortable', Sortable);
Stimulus.register('password-visibility', PasswordVisibility);
Stimulus.register('color-preview', ColorPreview);
Stimulus.register('clipboard', Clipboard);